"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.swapItemHere = exports.onEnter = exports.onCreate = void 0;
var assert_sidecar_1 = require("@lib/assert-sidecar");
var imports_1 = require("@lib/imports");
var common_1 = require("@main/common");
var common_sidecar_1 = require("@main/common-sidecar");
var voyageMessageCrewCarry_1 = require("@voyage/multi/voyageMessageCrewCarry");
var voyageMessageCrewCarry_sidecar_1 = require("@voyage/multi/voyageMessageCrewCarry-sidecar");
var voyageCarryableData_1 = require("@voyage/entities/voyageCarryableData");
var voyageCarryableData_sidecar_1 = require("@voyage/entities/voyageCarryableData-sidecar");
var voyageTilemap_sidecar_1 = require("@voyage/tilemap/voyageTilemap-sidecar");
var voyageWebsockets_sidecar_1 = require("@voyage/multi-sockets/voyageWebsockets-sidecar");
function onCreate(sys, text3, t) {
    // Try to spawn item
    var code = text3.substring(sys.data.startsWith.length + 1);
    var data = voyageCarryableData_sidecar_1.voyageCarryableData.tryFindByCode(code);
    if (data) {
        // console.log('CARRY', 'Create')
        if (voyageWebsockets_sidecar_1.voyageWebsockets.getIsHost()) {
            voyageMessageCrewCarry_sidecar_1.voyageMessageCrewCarry.sendMessageAndImmediatelyExecute({
                command: voyageMessageCrewCarry_1.EVoyageCrewCarryCommand.Create,
                type: data.type,
                crewId: 0,
                carryId1: common_1.createId(),
                carryId2: 0,
                i: t.i,
                j: t.j,
            });
        }
        // let cy = voyageCarryable.create(data.type)
        // voyageCarryable.setAtTile(cy, t)
    }
}
exports.onCreate = onCreate;
function onEnter(obj, isFinalMove) {
    if (isFinalMove) {
        swapItemHere(obj, true);
    }
}
exports.onEnter = onEnter;
function swapItemHere(obj, doPutDown) {
    var ds = common_sidecar_1.common.getUpdateDeltaScaled();
    var d = obj.heroState;
    assert_sidecar_1.assert.notNil(d);
    var tHere = voyageTilemap_sidecar_1.voyageTilemap.getSafeIJ(obj);
    if (tHere) {
        var item1 = imports_1.l.find(obj.items, function (c) { return c.type !== voyageCarryableData_1.EVoyageCarryableType.Coffee; }) || null;
        var item2 = tHere.items[0] || null;
        if (voyageWebsockets_sidecar_1.voyageWebsockets.getIsHost()) {
            if (item1 && !item2) {
                if (item1.data.type === voyageCarryableData_1.EVoyageCarryableType.Coffee) {
                    return; // Can't place down coffee
                }
                // console.log('CARRY', 'Drop')
                if (doPutDown) {
                    voyageMessageCrewCarry_sidecar_1.voyageMessageCrewCarry.sendMessageAndImmediatelyExecute({
                        command: voyageMessageCrewCarry_1.EVoyageCrewCarryCommand.Drop,
                        type: item1.type,
                        crewId: obj.id,
                        carryId1: item1.id,
                        carryId2: 0,
                        i: obj.i,
                        j: obj.j,
                    });
                }
            }
            if (item1 && item2) {
                if (item1.data.type === voyageCarryableData_1.EVoyageCarryableType.Coffee) {
                    return; // Can't swap coffee
                }
                // console.log('CARRY', 'Swap')
                voyageMessageCrewCarry_sidecar_1.voyageMessageCrewCarry.sendMessageAndImmediatelyExecute({
                    command: voyageMessageCrewCarry_1.EVoyageCrewCarryCommand.Swap,
                    type: item2.type,
                    crewId: obj.id,
                    carryId1: item1.id,
                    carryId2: item2.id,
                    i: obj.i,
                    j: obj.j,
                });
            }
            if (!item1 && item2) {
                // Pickup
                //console.log('CARRY', 'Pickup')
                voyageMessageCrewCarry_sidecar_1.voyageMessageCrewCarry.sendMessageAndImmediatelyExecute({
                    command: voyageMessageCrewCarry_1.EVoyageCrewCarryCommand.Pickup,
                    type: item2.type,
                    crewId: obj.id,
                    carryId1: item2.id,
                    carryId2: 0,
                    i: obj.i,
                    j: obj.j,
                });
            }
        }
    }
}
exports.swapItemHere = swapItemHere;
